export const COLLECTION_TYPE = {
  WORKOUT: "workout",
  RECIPE: "recipe",
  FOOD: "food",
  RESOURCE: "resource",
};
